import "./profile-navbar.css";
import { Link as RouterLink } from "react-router-dom";
import { Image, Link } from "@chakra-ui/react";
import logo from "../../images//hypospadiaslogo.png";
import { useAuthContext } from "../../auth-check/authContext";
export default function ProfileNavbar(props) {
  const { setIsAuthed } = useAuthContext();
  const logOut = () => {
    props.setIsMenuOpen(false);
    setIsAuthed(false);
    localStorage.clear();
  };

  return (
    <>
      <nav className='profile-navbarItems'>
        <div className='profile-navbar-left'>
          <Link as={RouterLink} to='/' _focus={{ textDecoration: "none" }}>
            <Image src={logo} className='profile-navbar-logo' />
          </Link>
        </div>

        <div className='profile-navbar-right'>
          <div
            className='profile-menu-icon'
            onClick={() => props.setIsMenuOpen(!props.isMenuOpen)}
          >
            <i
              className={props.isMenuOpen ? "fas fa-times" : "fas fa-bars"}
            ></i>
          </div>
          <ul
            className={
              props.isMenuOpen ? "profile-nav-menu active" : "profile-nav-menu"
            }
          >
            <li>
              <Link
                as={RouterLink}
                className='profile-nav-links'
                to='upload'
                onClick={() => props.setIsMenuOpen(false)}
                _focus={{ textDecoration: "none" }}
                _hover={{ textDecoration: "none" }}
              >
                Upload Photo
              </Link>
            </li>
            <li>
              <Link
                as={RouterLink}
                className='profile-nav-links'
                to='guidelines'
                onClick={() => props.setIsMenuOpen(false)}
                _focus={{ textDecoration: "none" }}
                _hover={{ textDecoration: "none" }}
              >
                Guidelines
              </Link>
            </li>
            <li>
              <Link
                as={RouterLink}
                to='/'
                className='profile-nav-links'
                onClick={logOut}
                _focus={{ textDecoration: "none" }}
                _hover={{ textDecoration: "none" }}
              >
                Log Out
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}
